import AddPost from '../components/PostPage/AddPost';

export default function AddPostPage() {
  return <AddPost />;
}
